<template>
  <v-app  :dark="!light" :light="light">
    <v-toolbar app color="primary" :extended="!!user" :extension-height="uploadBar ? '56px' : '4px'" flat>
      <v-btn icon @click="drawer = !drawer" v-if="!!user">
        <v-icon color="white">
          mdi-menu
        </v-icon>
      </v-btn>

      <v-toolbar-title class="text-uppercase white--text">
        <span class="mr-2">AMCCRS</span>
        <span class="font-weight-light">EVR</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn @click="_cbRefreshDb" v-if="user" icon>
        <v-icon :color="!dbFresh ? 'yellow' : 'white'">mdi-database-refresh</v-icon>
      </v-btn>
      <v-btn @click="_cbRefresh" v-if="user" icon>
        <v-badge color="red" :value="!!refreshCount" left overlap>
          <template v-slot:badge>
            <span style="font-size: .75em">
              {{refreshCount + 100 > 100 ? '99+' : refreshCount}}
            </span>
          </template>
          <v-icon :color="refreshCount ? 'yellow' : 'white'">mdi-refresh</v-icon>
        </v-badge>
      </v-btn>

      <template v-slot:extension v-if="!!user">
        <div style="width: 100%">
          <v-progress-linear height="4" color="yellow" class="my-0" indeterminate v-if="networkBusy">
          </v-progress-linear>
        </div>
      </template>

      <template v-slot:extension v-if="!!user && uploadBar">
        <div style="width: 100%">
          <v-progress-linear height="2" color="yellow" class="my-0" indeterminate v-if="networkBusy">
          </v-progress-linear>

          <v-progress-linear height="36" color="accent" class="my-0" :value="progress">
            <div class="pl-2 white--text" style="display: flex; align-items: center; justify-content: space-between; height: 100%">
              <v-btn icon @click="openDeleteSheet" :disabled="!filesCount" class="ma-0">
                <v-icon color="deep-orange lighten-3">mdi-delete</v-icon>
              </v-btn>
              <v-btn  class="mr-2" @click="_cbToggleMessages" icon :disbaled="!filesCount">
                <v-icon  color="white">mdi-message-alert</v-icon>
              </v-btn>
              <span class="caption">{{filesDone}} din {{filesCount}} fisiere ({{filesSize}})</span>
              <v-icon :color="online === 'on' ? 'white' : online === 'off' ? 'red' : 'deep-orange accent-1'" >
                <template v-if="online === 'on'">mdi-wifi-strength-4</template>
                <template v-else-if="online === 'off'">mdi-wifi-strength-off</template>
                <template v-else>mdi-wifi-strength-4-alert</template>
              </v-icon>
              <v-btn icon @click="startUpload" :disabled="!filesCount" class="ma-0" v-if="workerStop">
                <v-icon color="white" >mdi-cloud-upload</v-icon>
              </v-btn>
              <v-btn icon @click="pauseUpload" class="ma-0" v-else>
                <v-icon color="white" >mdi-pause</v-icon>
              </v-btn>
            </div>
          </v-progress-linear>

          <v-progress-linear height="2" color="yellow" class="my-0" :value="progressOne">
          </v-progress-linear>
        </div>
      </template>
    </v-toolbar>

    <v-navigation-drawer
      v-if="!!user"
      v-model="drawer"
      app
      hide-overlay
      disable-route-watcher
      :dark="!light"
      absolute
      stateless
      touchless
      :temporary="drawerType === 'temporary'"
      :permanent="drawerType === 'permanent'"
      clipped>
      <div class="d-flex" style="flex-direction: column; height: 100%">
        <v-list style="flex: 0 !important">
          <v-list-tile>
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'" v-if="user && user.admin">mdi-shield-account</v-icon>
              <v-icon :color="light ? 'accent' : 'white'" v-if="user && user.user">mdi-camera</v-icon>
              <v-icon :color="light ? 'accent' : 'white'" v-if="user && user.excel">mdi-file-excel</v-icon>
              <v-icon :color="light ? 'accent' : 'white'" v-if="user && user.pdf">mdi-file-pdf-box</v-icon>
              <v-icon :color="light ? 'accent' : 'white'" v-if="user && user.dummy">mdi-snowman</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ user && user.username }}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action @click="drawer = !drawer">
              <v-icon :color="light ? 'accent' : 'white'">mdi-chevron-left</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-list dense style="flex: 0 !important">
          <v-divider></v-divider>

          <v-list-tile @click="getLocation">
            <v-list-tile-action>
              <img src="img/pwa-logo-48-transparent.png" width="24">
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Localizare {{ watchingPosition ? 'pornita' : 'oprita'}}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon :color="watchingPosition ? 'warning' : (light ? 'accent' : 'white')">
                {{ watchingPosition ? 'mdi-map-marker' : 'mdi-map-marker-off' }}
              </v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="light = !light">
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                mdi-lightbulb
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{light ? 'Luminos' : 'Intunecat'}}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                {{ light ? 'mdi-weather-sunny' : 'mdi-weather-night' }}
              </v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="drawerType = drawerType === 'temporary' ? 'permanent' : 'temporary'" v-if="$vuetify.breakpoint.mdAndUp">
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                mdi-menu
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Meniu {{ drawerType === 'temporary' ? 'temporar' : 'permanent' }}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                {{ drawerType === 'temporary' ? 'mdi-menu-open' : 'mdi-pin' }}
              </v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-divider></v-divider>

          <v-list-tile @click="_cbToggleAutoRefresh">
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                mdi-refresh
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Auto-reincarca baza de date
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon :color="autoRefresh ? 'white' : 'primary'">
                {{ autoRefresh ? 'mdi-check' : 'mdi-close' }}
              </v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <!-- <v-list-tile @click="_cbRefreshDb">
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                mdi-database-refresh
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Reincarca baza de date
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="!dbFresh">
              <v-icon color="warning">
                mdi-exclamation
              </v-icon>
            </v-list-tile-action>
          </v-list-tile> -->

          <v-list-tile @click="_cbRefreshWindow">
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                mdi-reload-alert
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Reincarca aplicatie
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="_cbReloadWorker">
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                mdi-account-hard-hat
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Reincarca modul upload
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                mdi-wifi
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <template v-if="online === 'on'">Conexiune existenta</template>
                <template v-else-if="online === 'off'">Conexiune inexistenta</template>
                <template v-else>Conexiune slaba</template>
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon :color="online === 'on' ? (light ? 'accent' : 'white') : online === 'off' ? 'red' : 'deep-orange accent-1'" >
                <template v-if="online === 'on'">mdi-wifi-strength-4</template>
                <template v-else-if="online === 'off'">mdi-wifi-strength-off</template>
                <template v-else>mdi-wifi-strength-4-alert</template>
              </v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="openDeleteSheet">
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                mdi-delete
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Info poze
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text>
                {{ filesCount }}
              </v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="_cbToggleMessages">
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                mdi-message-alert
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Mesaje
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text>
                {{ messages.length }}
              </v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
        </v-list>

        <v-spacer></v-spacer>

        <v-card :color="light ? 'blue-grey lighten-4' : 'blue-grey darken-4'" style="flex: 0 !important">
          <v-card-title>
            Stare si statistici upload
            <v-spacer></v-spacer>
            <v-btn icon @click="_cbToggleUploadBar">
              <v-icon :color="uploadBar ? 'primary' : 'white'">{{ uploadBar ? 'mdi-pin' : 'mdi-pin-off' }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-list>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon :color="light ? 'accent' : 'white'">
                    mdi-image-multiple
                  </v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{filesDone}} din {{filesCount}} fisiere
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{filesSize}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-progress-linear height="12" color="primary" class="mb-1" :value="progress">
            </v-progress-linear>
            <v-progress-linear height="4" color="accent" class="my-0" :value="progressOne">
            </v-progress-linear>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="startOrStopUpload" :disabled="!filesCount" flat>
              <v-icon :color="light ? 'accent' : 'white'" left>
                {{ workerStop ? 'mdi-cloud-upload' : 'mdi-pause' }}
              </v-icon>
              {{ workerStop ? 'Start': 'Stop' }} upload
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>

        <v-spacer></v-spacer>

        <v-list style="flex: 0 !important">
          <v-divider></v-divider>
          <v-list-tile @click="_cbLogout">
            <v-list-tile-action>
              <v-icon :color="light ? 'accent' : 'white'">
                mdi-logout
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Iesire din aplicatie
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-content>
      <!-- <transition :name="transitionName" mode="out-in"> -->
        <router-view/>
      <!-- </transition> -->
    </v-content>

    <v-bottom-nav :value="!!user" app :color="light ? 'white' : 'grey darken-4 white--text'" :light="light">
      <!-- <v-btn flat :color="onColor" to="/">
        <span>Acasa</span>
        <v-icon>mdi-home</v-icon>
      </v-btn> -->
      <v-btn flat :color="onColor" to="/entities">
        <span>Simboluri</span>
        <v-icon>mdi-map-marker-radius</v-icon>
      </v-btn>
      <v-btn flat :color="onColor" to="/map">
        <span>Harta</span>
        <v-icon>mdi-map</v-icon>
      </v-btn>
      <!-- <v-btn flat :color="onColor" to="/photos">
        <span>Poze</span>
        <v-icon>mdi-image-multiple</v-icon>
      </v-btn> -->

      <v-btn flat :color="onColor" to="/reminders" v-if="user">
        <span>Calendar</span>
        <v-icon>mdi-calendar-alert</v-icon>
      </v-btn>

      <span style="flex-grow:0; flex-shrink: 0">
        <v-menu offset-y v-if="user && user.admin">
          <template v-slot:activator="{ on }">
            <v-btn flat v-on="on">
              <span>Admin</span>
              <v-icon>mdi-account-cog</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile to="/dashboard">
              <v-list-tile-avatar>
                <v-icon>mdi-monitor-dashboard</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>
                Dashboard
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile to="/users">
              <v-list-tile-avatar>
                <v-icon>mdi-account</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>
                Users
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile to="/diff">
              <v-list-tile-avatar>
                <v-icon>mdi-clock</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>
                Istoric
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </span>

      <!-- <v-btn flat :color="onColor" to="/dashboard" v-if="user && user.admin">
        <span>Dashboard</span>
        <v-icon>mdi-monitor-dashboard</v-icon>
      </v-btn>
      <v-btn flat :color="onColor" to="/users" v-if="user && user.admin">
        <span>Users</span>
        <v-icon>mdi-account</v-icon>
      </v-btn>
      <v-btn flat :color="onColor" to="/diff" v-if="user && user.admin">
        <span>Istoric</span>
        <v-icon>mdi-clock</v-icon>
      </v-btn> -->
    </v-bottom-nav>

    <v-bottom-sheet v-model="deleteSheet" hide-overlay>
      <v-list three-line dense style="max-height: 35vh; overflow-y: auto">
        <v-subheader>Fisiere in lista de asteptare:</v-subheader>

        <v-subheader>
          <v-text-field
            :value="filesFilterByEntity"
            @input="setFilesFilter"
            clearable
            :suffix="`${filteredFiles.length}`"
            label="Filtru id scara">
          </v-text-field>
        </v-subheader>

        <v-list-tile
          v-for="file in filteredFiles"
          :key="file.id">
          <v-list-tile-action style="color: grey">
            <v-icon small :color="file.tip === 'photo' ? 'primary' : (file.tip === 'pdf' ? 'error' : 'green')">
              {{ file.tip === 'photo' ? 'mdi-camera' : (file.tip === 'pdf' ? 'mdi-file-pdf-box' : 'mdi-file-excel') }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ file.idObiectiv || file.name }}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ prettyB(file.size) }}
              {{ (new Date(file.lastModified)).toLocaleString('ro-RO') }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title>
              <v-chip outline small>{{file.parent}}</v-chip>
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action @click="removeRef(file)">
            <v-btn icon v-if="!file.uploaded">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
            <v-icon color="primary" v-else>mdi-check</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="messagesOpen" hide-overlay>
      <v-list dense three-line style="max-height: 35vh; overflow-y: auto">
        <v-subheader style="disdplay_flex; justify-content: space-between">
          Notificari si mesaje (ultimele 20)
          <v-spacer></v-spacer>
          <v-btn small icon @click="_cbClearMessages">
            <v-icon small color="error">mdi-delete-sweep</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small icon @click="_cbToggleMessages">
            <v-icon small color="error">mdi-close</v-icon>
          </v-btn>
        </v-subheader>
        <v-list-tile
          v-for="message in messages"
          :key="message.id">
          <v-list-tile-action>
            <v-icon :color="message.type === 'fail' ? 'error' : (message.type === 'warning' ? 'warning' : 'success')">
              {{ getMessageIcon(message) }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ message.timestamp.toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }) }}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ message.text}}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon color="error" @click="_cbDeleteMessage(message.id)">
              mdi-delete
            </v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>
  </v-app>
</template>

<script>
import prettyBytes from 'pretty-bytes'
import debounce from 'lodash.debounce'

export default {
  name: 'App',
  data () {
    return {
      transitionName: 'slide-x-transition',
      deleteSheet: false,
      filesFilterByEntity: null,
      drawer: null,
      drawerType: 'temporary'
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
    light: {
      get () {
        return this.$store.getters.light
      },
      set (value) {
        this.$store.commit('setLight', value)
      }
    },
    uploadBar: {
      get () {
        return this.$store.getters.uploadBar
      },
      set (value) {
        this.$store.commit('setUploadBar', value)
      }
    },
    autoRefresh: {
      get () {
        return this.$store.getters.autoRefresh
      },
      set (value) {
        this.$store.commit('setAutoRefresh', value)
      }
    },
    online () {
      return this.$store.getters.online
    },
    files () {
      return this.$store.getters['entities/files']
    },
    filteredFiles () {
      if (this.filesFilterByEntity) {
        return this.files.filter(file => file.idObiectiv.toLowerCase().includes(this.filesFilterByEntity.toLowerCase()))
      } else {
        return this.files
      }
    },
    filesCount () {
      return this.$store.getters['entities/filesCount']
    },
    filesSize () {
      return this.$store.getters['entities/filesSize']
    },
    filesDone () {
      return this.$store.getters['entities/filesDone']
    },
    progress () {
      return this.filesCount ? this.filesDone * 100 / this.filesCount : 0
    },
    progressOne () {
      return this.$store.getters['entities/progressOne']
    },
    workerStop () {
      return this.$store.getters['entities/workerStop']
    },
    messages () {
      return this.$store.getters.messages
    },
    messagesOpen: {
      get () {
        return this.$store.getters.messagesOpen
      },
      set (value) {
        this.$store.commit('setMessagesOpen', value)
      }
    },
    isDetailsEdited () {
      return this.$store.getters.isDetailsEdited
    },
    refreshCount () {
      return this.$store.getters.refreshCount
    },
    onColor () {
      return this.$store.getters.onColor
    },
    offColor () {
      return this.$store.getters.offColor
    },

    networkBusy () {
      return this.$store.getters.networkBusy
    },
    dbFresh () {
      return this.$store.getters['entities/dbFresh']
    },
    watchingPosition () {
      return this.$store.getters.watchingPosition
    },
    gettingPosition () {
      return this.$store.getters.gettingPosition
    },
    wannaWatchPosition () {
      return this.$store.getters.wannaWatchPosition
    }
  },
  watch: {
    filesCount (val) {
      if (!val && this.deleteSheet) this.deleteSheet = false
    }
  },
  methods: {
    _cbToggleAutoRefresh () {
      this.autoRefresh = !this.autoRefresh
    },
    _cbToggleUploadBar () {
      this.uploadBar = !this.uploadBar
    },
    startOrStopUpload () {
      if (this.workerStop) {
        this.startUpload()
      } else {
        this.pauseUpload()
      }
    },
    setFilesFilter: debounce(function ($event) {
      // console.log($event)
      this.filesFilterByEntity = $event
    }, 1000),
    prettyB (size) {
      return prettyBytes(size)
    },
    _cbLogout () {
      this.$dialog
        .confirm({
          title: 'Vreti sa va inchideti seisunea de lucru?',
          body: 'Daca inchideti sesiunea de lucru va trebui sa va reautentificati!'
        }, {
          okText: 'DA, inchid!',
          cancelText: 'Nu, raman!',
          animation: 'zoom'
        }, { animation: 'bounce' })
        .then(dialog => {
          this.$store.dispatch('logout')
            .then(res => {
              this.$router.push({ name: 'login' })
            })
            .catch(err => {
              console.log('err', err)
              this.$router.push({ name: 'login' })
            })
        })
        .catch(() => {

        })
    },
    getLocation () {
      if (this.user) {
        // this.$store.dispatch('getLocation')
        if (!this.watchingPosition) {
          this.$store.commit('setWannaWatchPosition', true)
          this.$store.dispatch('setupPositionWatcher')
        } else {
          this.$store.commit('setWannaWatchPosition', false)
          this.$store.dispatch('stopPositionWatcher')
        }
      }
    },
    async startUpload () {
      if (this.$router.currentRoute && this.$router.currentRoute.name === 'details') {
        // i really really really don't like this
        // this.$children[0].$children[1].$children[0].isEdited
        if (this.isDetailsEdited) {
          try {
            await this.$dialog
              .confirm({
                title: 'Atentie!',
                body: 'Daca vei porni upload-ul, vei pierde modificarile nesalvate! Doresti sa continui?'
              }, {
                okText: 'DA',
                cancelText: 'Nu',
                animation: 'zoom'
              })
          } catch (e) {
            return
          }
        }
      }

      if (this.online === 'lie-fi') {
        this.$dialog
          .confirm({
            title: 'Atentie!',
            body: 'Conexiunea la Internet este de tip LIE-FI (cea mai simpla comunicare cu serverul dureaza mai mult de 5 secunde). Esti sigur ca vrei sa incerci upload-ul?'
          }, {
            okText: 'DA',
            cancelText: 'Nu, incerc mai tarziu!',
            animation: 'zoom'
          })
          .then(dialog => {
            this.$store.dispatch('entities/uploadPhotos')
          })
          .catch(() => {})
      } else {
        this.$store.dispatch('entities/uploadPhotos')
      }
      this.$store.dispatch('entities/uploadPhotos')
    },
    openDeleteSheet () {
      this.deleteSheet = true
    },
    removeRef (file) {
      if (!file.uploaded) this.$store.commit('entities/removeFile', file)
    },
    pauseUpload () {
      this.$store.dispatch('entities/pauseUpload')
    },
    _cbToggleMessages () {
      this.messagesOpen = !this.messagesOpen
    },
    _cbDeleteMessage (id) {
      this.$store.commit('deleteMessage', id)
    },
    _cbClearMessages () {
      this.$store.commit('deleteAllMessages')
    },

    getMessageIcon (message) {
      switch (message.tip) {
        case 'photo': return 'mdi-camera'
        case 'pdf': return 'mdi-file-pdf-box'
        case 'excel': return 'mdi-file-excel'
        case 'test': return 'mdi-speedometer'
        case 'error': return 'mdi-alert-circle'
        case 'success': return 'mdi-check-circle'
        case 'info': return 'mdi-information-outline'
        case 'auth': return 'mdi-lock'
      }
    },
    async _cbRefresh () {
      if (this.$router.currentRoute && this.$router.currentRoute.name === 'details') {
        // i really really really don't like this
        // this.$children[0].$children[1].$children[0].isEdited
        if (this.isDetailsEdited) {
          try {
            await this.$dialog
              .confirm({
                title: 'Atentie!',
                body: 'Daca vei "face refresh", vei pierde modificarile nesalvate! Doresti sa continui?'
              }, {
                okText: 'DA',
                cancelText: 'Nu',
                animation: 'zoom'
              })
          } catch (e) {
            return
          }
        }
      }

      // console.log('app refresh')

      this.$store.dispatch('entities/fetchEntities')
      // this.$store.dispatch('entities/fetchAllEntities')
      this.$store.dispatch('entities/setActiveEntity')
    },
    async _cbReloadWorker () {
      try {
        await this.$dialog
          .confirm({
            title: 'Atentie!',
            body: 'Esti sigur ca vrei sa reincarci modulul de upload?'
          }, {
            okText: 'DA',
            cancelText: 'Nu',
            animation: 'zoom'
          })
      } catch (e) {
        return
      }
      this.$store.dispatch('entities/setupWorker')
    },
    async _cbRefreshWindow () {
      try {
        await this.$dialog
          .confirm({
            title: 'Atentie!',
            body: 'Esti sigur ca vrei sa reincarci toata aplicatia?'
          }, {
            okText: 'DA',
            cancelText: 'Nu',
            animation: 'zoom'
          })
      } catch (e) {
        return
      }
      window.location.reload()
    },
    async _cbRefreshDb () {
      this.$store.dispatch('entities/refreshAllEntities')
    }

    // handleVisibilityChange () {
    //   console.log(document.hidden)
    // }
  },
  mounted () {
    // document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
    this.$store.dispatch('setOnlineOfflineHandler')

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        if (this.watchingPosition) {
          this.$store.dispatch('stopPositionWatcher')
          // console.log('stopping position watcher')
        }
      } else {
        if (this.wannaWatchPosition) {
          this.$store.dispatch('setupPositionWatcher')
          // console.log('resuming position watcher')
        }
      }
    })

    if (this.wannaWatchPosition) {
      this.$store.dispatch('setupPositionWatcher')
    }
  }
}
</script>

<style lang="stylus">
  .v-calendar-daily_head-day-label {
    font-size: 32px !important;
  }

  body, .no-rubber, html {
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: none;
  }

.dg-content-body--has-title .dg-content {
  font-size: 20px !important;
}

// .content-visibility-auto {
//   content-visibility: auto
// }

.photo-div {
  content-visibility: auto
  // width: 64px
  // height: 124.25px
  contain-intrinsic-size: 64px 124.25px
}

img.photo {
  position: relative

  &::before {
    content: ''
    display: block
    width: 100%
    height: 100%
    background-color: rgba(255, 0, 0, .75)
    position: absolute
    top: 50%
    left: 0
    border-radius: 100%
    transform: translateY(-50%)
  }

  &::after {
    content: "\2639"

    font-size: 18px
    line-height: 44px
    text-align: center
    color: white

    display: block
    position: absolute
    z-index: 2
    top: 50%
    left: 0
    width: 100%
    height: 100%
    transform: translateY(-50%)
  }
}

.filename-truncation {
  width: 100%;
  overflow-wrap: break-word;
  font-size: .75em;
  text-align: center;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.d-layout {
  display: flex;
  flex-wrap: wrap;
}

.v-toolbar__extension {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.color-input input {
  max-height: 50px !important;
  height: 50px !important;
}

input:not([readonly]), textarea {
  border-bottom: thin solid #eee;
}

input[type="file"] {
  border-bottom: none;
}

.data-loading {
  animation-name: loading
  animation-duration: 1.5s
  animation-timing-function: ease-out
  animation-delay: 0s
  animation-direction: alternate
  animation-iteration-count: infinite
  animation-fill-mode: none
  animation-play-state: running
}

@keyframes loading {
  from {
    opacity: 1
  }
  to {
    opacity: 0.2
  }
}

.fadeTr-enter-active {
  transition: none !important;
}
.fadeTr-leave-active {
  transition: none !important;
}
.fadeTr-enter, .fadeTr-leave-to {
  opacity: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: none !important;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
  -webkit-transform: translateX(30px);
          transform: translateX(30px);
}
.dg-backdrop-enter-active {
  animation: none !important;
}
.dg-backdrop-leave-active {
  animation: none !important;
}
.dg-fade-enter-active {
  animation: none !important;
}
.dg-fade-leave-active {
  animation: none !important;
}

.dg-zoom-enter-active {
  animation: none !important;
}
.dg-zoom-leave-active {
  animation: none !important;
}

.dg-bounce-enter-active {
  animation: none !important;
}
.dg-bounce-leave-active {
  animation: none !important;
}

// .v-tabs__item--active {
//   color: var(--v-accent-base) !important;
// }

.dg-btn {
  border: none !important;
  font-family:Roboto, sans-serif;
  font-size:14px;
  font-stretch:100%;
  font-style:normal;
  font-variant-caps:normal;
  font-variant-east-asian:normal;
  font-variant-ligatures:normal;
  font-variant-numeric:normal;
  font-weight:500;
  -webkit-font-smoothing:antialiased;
  text-align:center;
  text-indent:0px;
  text-rendering:auto;
  text-shadow:none;
  text-size-adjust:100%;
  text-transform:uppercase;
}
.dg-btn--ok {
  // verde
  color: var(--v-primary-base) !important;
}
.dg-btn--cancel {
  // rosu
  background-color: transparent !important;
  color: var(--v-error-base) !important;
}

details {
    border-radius: 4px;
    padding: .5em .5em 0;
}

summary {
    font-weight: bold;
    margin: -.5em -.5em 0;
    padding: .5em;
    outline: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    min-height: 50px;
    align-items: center;
}

details[open], details[open] summary {
    padding: .5em;
    // margin-bottom: .5em;
}

details[open] div::first-of-type {
    // border-bottom: 1px solid #aaa;
    margin-bottom: .5em;
    padding-left: 1em;
}

// details input, details textarea, details summary.editable {
//   color: var(--v-accent-base) !important;
// }
details summary:not(.editable) {
  color: #999 !important;
}

.deletePhoto, .deletePdf, .deleteExcel {
  border: 1px solid var(--v-error-base) !important;
  background-color: var(--v-error-base) !important;
}

.badPhoto, .badPdf, .badExcel {
  border: 1px solid var(--v-warning-base) !important;
  background-color: var(--v-warning-base) !important;
}

.normalPhoto {
  border: 1px dashed var(--v-primary-base) !important;
  background-color: white !important;
}
.normalExcel {
  border: 1px dashed var(--v-excel-base) !important;
  background-color: white !important;
}
.normalPdf {
  border: 1px dashed var(--v-pdf-base) !important;
  background-color: white !important;
}

.viewerPhoto {
  border: 1px solid var(--v-primary-base) !important;
  background-color: white !important;
}
.viewerExcel {
  border: 1px solid var(--v-excel-base) !important;
  background-color: white !important;
}
.viewerPdf {
  border: 1px solid var(--v-pdf-base) !important;
  background-color: white !important;
}

.changelog p {
  text-align: justify;
}

// .v-window-item > .v-card__text.pa-0  {
//   padding-left: 1em !important;
//   padding-right: 1em !important;
// }

.share-logo {
  cursor: pointer;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 100%;
    box-shadow: 0 0 20px 0 white;
    background-color: white;
    opacity: 0;
  }
}

.share-busy {
  // outline: 2px solid var(--v-warning-base);
  box-shadow: 0 0 4px 2px white;
  position: relative;
}

.share-watching {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('/img/position.png');
  background-color: rgba(255, 255, 255, .5);
  background-size: 75%;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 100%;
}

.share-animate {
  &::after {
    animation: glow 3s ease-in-out infinite;
  }
}

@keyframes glow {
  0% {
    opacity: 0;
  }
  50% {
    opacity: .5;
  }
  100% {
    opacity: 0;
  }
}
</style>
